import React, { useState, useEffect } from 'react';
import { Anchor, Flex, Row, Col } from 'antd';
import { PageSection, PageContent, AnchorSection } from '../../styles/global/Pages.styled';
import { Widget } from "../Global/Atomics/Widget";
import { Text } from '../Global/Atomics/Text';
import useFetch from '../../server/useFetch';
import query, { containerMiddlewareAdEPorto } from '../../server/constants.api';
import { SelectAtomic } from '../Global/Atomics/SelectAtomic';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useGlobalFilterContext } from '../../contexts/GlobalFilterProvider';
import Spinner from '../Global/Atomics/Spinner';
import MouseoverTooltip from '../Global/Atomics/MouseoverTooltip';

export const Ciris = () => {//Deloitte
    //#region synergyComment: UseStates and UseEffects of Ciris Page
    const { t } = useTranslation();//the function t is used to translate the page
    const [userTenant] = useState(localStorage.getItem(`adeporto_tenant`));
    const topRef = React.useRef < HTMLDivElement > (null);
    const [targetOffset, setTargetOffset] = useState();
    const [isSticky, setIsSticky] = useState(false);
    //defines a useState by null in inicializing for the dropdowns date and years to fecth 
    const [dropdownDates, setDropdownDates] = useState(null);
    const [yearsToFetch, setYearsToFetch] = useState(null);
    const [disableDropdown, setDisableDropdown] = useState(false);

    //defines the dropdownMunicipalities array by empty when starting
    const [dropdownMunicipalities, setDropdownMunicipalities] = useState([]);
    //defines the municipalities Years and which municipalities to fetch useStates at null in the begining
    const [municipalitiesAndYears, setMunicipalitiesAndYears] = useState(null);
    //defines the energyTypesDropdown array by empty when starting
    const [energyTypesDropdown, setEnergyTypesDropdown] = useState([]);
    const [energyTypeSelected, setEnergyTypeSelected] = useState('Total');

    const { entityToFetch, handleEntitiesOptionsChange } = useGlobalFilterContext();

    const { data: municipalitiesCIRIS, isFetching: municipalitiesCIRISIsFetching, refetch: refetchMunicipalitiesCIRIS } = useFetch(
        "ciris/dropdowns",
        "municipalitiesCIRIS",
        {
            tenant: 'TOP/ADEPORTO',
            lang: 'PT'
        },
        null,
        null,
        containerMiddlewareAdEPorto
    );

    const { data: energyTypesData, isLoading: energyTypesDataIsLoading, refetch: refetchEnergyTypesData, isFetching: energyTypeIsFetching } = useFetch(query.path.energyTypesDropdown, 'getEnergyTypesDropdown', { language: i18next.resolvedLanguage });

    // State for tooltip content
    const [tooltipContent, setTooltipContent] = useState(null);

    useEffect(() => {
        // Set tooltip content based on language
        if (i18next.resolvedLanguage === 'en') {
            setTooltipContent({
                iconText: [
                    { text: "Scope 1: Direct Emissions" },
                    { text: "Scope 2: Indirect Emissions" },
                    { text: "Scope 3: Outside City Boundary" },
                ],
            })
        } else {
            setTooltipContent({
                iconText: [
                    { text: "Âmbito 1: Emissões Diretas" },
                    { text: "Âmbito 2: Emissões Indiretas" },
                    { text: "Âmbito 3: Fora dos Limites da Cidade" },
                ],
            })
        }
        refetchEnergyTypesData();
    }, [i18next.resolvedLanguage])

    //useEffect used to populate the dropdowns with the data Municipalities
    useEffect(() => {
        try {
            if (municipalitiesCIRIS?.data && entityToFetch) {
                const data = municipalitiesCIRIS?.data?.[0]?.Value?.filter(x => x.tenant.includes(JSON.parse(userTenant)?.[0])) ?? {};
                setMunicipalitiesAndYears(data);

                const municipalities = [];
                data?.forEach(x => {
                    const entityLabel = x.tenant.split('/');
                    municipalities.push({
                        value: x.tenant,
                        label: entityLabel[entityLabel.length - 1]
                    });
                    if (entityToFetch?.value === x.tenant) {
                        setDropdownDates(
                            x.years
                                ?.map(y => { return { value: y, label: y } })
                                ?.sort((a, b) => a.value - b.value)
                        );
                    }
                })
                setDropdownMunicipalities(municipalities);
                if (municipalities?.length > 0) {
                    const datesByMunicipality = data?.find(x => x.tenant === entityToFetch?.value);
                    const datesToFilter = datesByMunicipality?.years?.map(x => { return { value: x, label: x } });
                    setDropdownDates(datesToFilter?.sort((a, b) => a.value - b.value));
                    setYearsToFetch([datesToFilter[datesToFilter.length - 1]?.value]);
                } else {
                    setDropdownDates(null);
                    setYearsToFetch(null);
                }
            }
        } catch (error) {
            console.error('(Ciris page) Error in populating of municipalities dropdown:', error);
            //reportError(error); // Send error report to backend
        }
    }, [entityToFetch, municipalitiesCIRIS?.data]);

    //useEffect used to populate the dropdown with the data energy Types
    useEffect(() => {
        try {
            if (energyTypesData?.data) {
                setEnergyTypesDropdown(energyTypesData?.data);
                // logger.info('User populate the dropdown with data energy types');
            }
        } catch (error) {
            // logger.error('Error in useEffect setting energy types on dropdown');
            console.error('(Ciris page) Error in useEffect setting energy types on dropdown:', error);
            //reportError(error); // Send error report to backend
        }
    }, [energyTypesData?.data, energyTypeIsFetching])

    //useEffect to setting target offset and to handle scroll 
    useEffect(() => {
        try {
            setTargetOffset(topRef.current?.clientHeight);
            const handleScroll = () => {
                if (window.scrollY > 50) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            };

            window.addEventListener('scroll', handleScroll);

            // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        } catch (error) {
            console.error('(Ciris page) Error in useEffect stting target offset and handlingScroll:', error);
            //reportError(error); // Send error report to backend
        }
    }, []);
    //#endregion

    // Function to handle options change for years dropdown
    function handleOptionsChange(value) {
        try {
            // if (value && value.length > 0) {
            setYearsToFetch([value]);//Converted to array because it what the API receives as a param
            // }
            // logger.info('User changed option in years dropdown');
        } catch (error) {
            // logger.error('Error handling options change in years dropdown');
            console.error('(Ciris page) Error in handling options change:', error);
            //reportError(error); // Send error report to backend
        }
    };

    // Function to handle options change for municipalities dropdown
    function handleMunicipalityOptionsChange(record) {
        try {
            if (record) {
                const datesByMunicipality = municipalitiesAndYears?.find(x => x.tenant === record?.value);
                const datesToFilter = datesByMunicipality?.years?.map(x => { return { value: x, label: x } });
                setDropdownDates(datesToFilter?.sort((a, b) => a.value - b.value));
                setYearsToFetch([datesToFilter[datesToFilter.length - 1]?.value]);
                handleEntitiesOptionsChange(record);
                // logger.info('User changed option in municipalities dropdown');
            }
        } catch (error) {
            // logger.error('Error in useEffect handling municipality options change');
            console.error('(Ciris page) Error in useEffect handling municipality options change:', error);
            //reportError(error); // Send error report to backend
        }
    };

    //this function is used to handling Energy Types options change
    function handleEnergyTypesOptionsChange(value) {
        try {
            setEnergyTypeSelected(value);//Converted to array because it what the API receives as a param
            // logger.info('Handling Energy Types options change');
        } catch (error) {
            // logger.error('Error in handling energy types options change');
            console.error('(Ciris page) Error in handling energy types options change:', error);
            //reportError(error); // Send error report to backend
        }
    };

    // Function to set dropdown disabled state
    function fetchIsLoading(value) {
        try {
            setDisableDropdown(value);
        } catch (error) {
            console.error('(Ciris page) Error in fetchIsLoading:', error);
            //reportError(error); // Send error report to backend
        }
    }
    //#region Anchor Items

    //Charts data
    const [isToFetchEmissionsBySector, setIsToFetchEmissionsBySector] = useState(false);
    const [isToFetchEmissionsByScope, setIsToFetchEmissionsByScope] = useState(false);

    //Emissions by Scope
    const [dataEmissionsByScope, setEmissionsByScope] = useState(null);

    const {
        data: emissionsByScope,
        isLoading: emissionsByScopeLoading,
        refetch: refetchEmissionsByScope
    } = useFetch(query.path.emissionsByScope, 'getEmissionsByScope', { dates: JSON.stringify(yearsToFetch), tenant: entityToFetch?.value, language: i18next.resolvedLanguage }, isToFetchEmissionsByScope);

    useEffect(() => {
        if (emissionsByScope?.data) {
            setEmissionsByScope(emissionsByScope?.data?.data)
            // setYearEmissionsByScope(emissionsByScope?.data?.year)
            setIsToFetchEmissionsByScope(false);
        }
    }, [emissionsByScope?.data]);

    //Evolutions by Scope
    const {
        data: evolutionByScope,
        isLoading: evolutionByScopeLoading,
        refetch: refetchEvolutionByScope
    } = useFetch('/unified_temporary/ciris/evolutionByScope', 'getEvolutionByScope', { tenant: entityToFetch?.value, language: i18next.resolvedLanguage }, isToFetchEmissionsBySector);

    useEffect(() => {
        if (entityToFetch && yearsToFetch) {
            setIsToFetchEmissionsByScope(true);
            refetchEvolutionByScope();
        }
    }, [entityToFetch, yearsToFetch]);

    // Array of anchor items for the page
    const anchorsItems = [
        {
            key: 'Indicadores Geraiso',
            href: '#Indicadores Gerais',
            title: t('generalIndicators'),
        },
        {
            key: 'Emission distribution',
            href: '#Emission distribution',
            title: t('emissionsDistribution'),
        },
        {
            key: 'Energy consumption',
            href: '#Energy consumption',
            title: t('energyConsumption')
        },
        {
            key: 'Emissions flowchart',
            href: '#Emissions flowchart',
            title: t('flowchartEmissions')
        }
    ];

    //#endregion
    return (
        <PageContent>
            <div id='Indicadores Gerais'></div> {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
            <AnchorSection $backgroundColor='neutral-1' className="fixed-top">
                <Row justify="center" align="middle">
                    {!municipalitiesCIRISIsFetching ?
                        <>
                            <Col span={16}>
                                {dropdownDates?.length > 0 ?
                                    <Anchor replace={true} direction="horizontal" items={anchorsItems} />
                                    : null}
                            </Col>

                            <Col span={8} >
                                <Row gutter={[16, 16]}>
                                    <Col span={10}>
                                        {dropdownDates?.length > 0 ?
                                            <SelectAtomic optionsData={dropdownDates} handleOptionsChange={handleOptionsChange} defaultValue={dropdownDates?.[dropdownDates.length - 1]?.value} fullWidth={true} />
                                            : <div>{t('noDataResource')}</div>}
                                    </Col>
                                    {dropdownMunicipalities?.length > 0 ?
                                        <Col span={14}>
                                            <SelectAtomic optionsData={dropdownMunicipalities} handleOptionsChange={(value, record) => handleMunicipalityOptionsChange(record)} defaultValue={entityToFetch?.value} fullWidth={true} />
                                        </Col>
                                        : <Spinner stroke="green" size='28px' />
                                    }
                                </Row>
                            </Col>
                        </>
                        : <Spinner stroke="green" size='28px' />}
                </Row>
            </AnchorSection>
            {dropdownMunicipalities?.length >= 1 && dropdownDates?.length >= 1 ?
                <>
                    <PageSection $backgroundColor='neutral-1' className='solve-error-ciris'>
                        <Row>
                            <Col span={24}>
                                <div id='' className='ant-anchors-content-item-first'>
                                    <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginBottom='s08'>{t('generalIndicators')}</Text>
                                    <Row gutter={[16, 16]}>
                                        <Col span={8}>
                                            <Widget data={{
                                                height: '150px',
                                                background: 'white',
                                                title: 'totalEmissions',
                                                icon: 'Emissions',
                                                charts: [
                                                    {
                                                        chartType: 'bigNumberChart',
                                                        chartId: 'bigNumberChartThree',
                                                        chartQuery: '/unified_temporary/ciris/totalEmissions',
                                                        idQuery: 'getTotalEmissions'
                                                    }
                                                ]
                                            }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>
                                        <Col span={8}>
                                            <Widget data={{
                                                height: '150px',
                                                background: 'white',
                                                title: 'resultingEnergyConsumption',
                                                icon: 'Bolt',
                                                charts: [
                                                    {
                                                        chartType: 'bigNumberChart',
                                                        chartId: 'bigNumberChartThree',
                                                        chartQuery: '/unified_temporary/ciris/resultingEnergyConsumption',
                                                        idQuery: 'getResultingEnergyConsumption'
                                                    }
                                                ]
                                            }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>
                                        <Col span={8}>
                                            <Widget data={{
                                                height: '150px',
                                                background: 'white',
                                                title: 'carbonCapture',
                                                icon: 'Bolt',
                                                tooltip: t('estimatedValue'),
                                                charts: [
                                                    {
                                                        chartType: 'bigNumberChart',
                                                        chartId: 'bigNumberChartThree',
                                                        chartQuery: '/unified_temporary/ciris/carbonCapture',
                                                        idQuery: 'getCarbonCapture'
                                                    }
                                                ]
                                            }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>

                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </PageSection>
                    <div className="solve-error-ciris background-color-gray" id='Emission distribution'></div> {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
                    <PageSection $backgroundColor='white' className='solve-error-ciris'>
                        <Row>
                            <Col span={24}>
                                <div id='' className='ant-anchors-content-item'>
                                    <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginBottom='s08'>{t('emissionsDistribution')}</Text>
                                    <Row gutter={[16, 16]}>
                                        <Col span={12}>
                                            <Widget data={{
                                                height: '447px',
                                                background: null,
                                                border: 'neutral-3',
                                                title: 'sectorCO2Emissions',
                                                icon: 'Emissions',
                                                tooltip:
                                                    <MouseoverTooltip data={{
                                                        iconText: [
                                                            { text: t('IPPUTooltip') },
                                                            { text: t('AFOLUTooltip') },
                                                        ],
                                                    }} />,
                                                charts: [
                                                    {
                                                        chartType: 'simpleDonutChartApex',
                                                        chartId: 'donutChartOne',
                                                        chartQuery: '/unified_temporary/ciris/emissionsBySector',
                                                        idQuery: 'getEmissionsBySector'
                                                    }
                                                ]
                                            }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>
                                        <Col span={12}>
                                            <Widget data={{
                                                height: '447px',
                                                background: null,
                                                border: 'neutral-3',
                                                title: 'cO2EmissionsEvolution',
                                                icon: 'Emissions',
                                                tooltip:
                                                    <MouseoverTooltip data={{
                                                        iconText: [
                                                            { text: t('IPPUTooltip') },
                                                            { text: t('AFOLUTooltip') },
                                                        ],
                                                    }} />,
                                                charts: [
                                                    {
                                                        chartType: 'stackedColumnsChartApex',
                                                        chartId: 'verticalStackedBarChartOne',
                                                        idQuery: 'getEvolutionBySector',
                                                        chartQuery: '/unified_temporary/ciris/evolutionBySector',
                                                    }
                                                ]
                                            }} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>
                                        <Col span={12}>
                                            <Widget data={{
                                                height: '447px',
                                                background: null,
                                                border: 'neutral-3',
                                                title: 'emissionsScope',
                                                icon: 'Emissions',
                                                tooltip: <MouseoverTooltip data={tooltipContent} />,
                                                charts: [
                                                    {
                                                        chartType: 'simpleDonutChartApex',
                                                        chartId: 'donutChartOne',
                                                        idQuery: 'getEmissionsByScope',
                                                        chartQuery: '/unified_temporary/ciris/emissionsByScope',
                                                    }
                                                ]
                                            }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>
                                        <Col span={12}>
                                            <Widget data={{
                                                height: '447px',
                                                background: null,
                                                border: 'neutral-3',
                                                title: 'evolutionEmissionsScope',
                                                icon: 'Emissions',
                                                tooltip: <MouseoverTooltip data={tooltipContent} />,
                                                charts: [
                                                    {
                                                        chartType: 'stackedColumnsChartApex',
                                                        chartId: 'verticalStackedBarChartOne',
                                                        idQuery: 'getEvolutionByScope',
                                                        chartQuery: '/unified_temporary/ciris/evolutionByScope',
                                                    }
                                                ]
                                            }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </PageSection>
                    <div className="solve-error-ciris" id='Energy consumption'></div> {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
                    <PageSection $backgroundColor='neutral-1' className='solve-error-ciris' >
                        <Row gutter={[16, 16]} justify="center" align="middle">
                            <Col span={16}>
                                <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular'>{t('energyConsumption')}</Text>
                            </Col>
                            <Col span={8}>
                                <Row gutter={[16, 16]} align="middle" justify="end">
                                    <Col span={10}>
                                        <Flex horizontal="true" justify="flex-end">
                                            <Text $fontColor='coolgray-12' $fontSize='text_lg' $weight='regular'>{t('energyVector')}:</Text>
                                        </Flex>
                                    </Col>
                                    <Col span={14} className='select-xl-text'>
                                        <SelectAtomic optionsData={energyTypesDropdown} handleOptionsChange={handleEnergyTypesOptionsChange} defaultValue={energyTypeSelected} fullWidth={true} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={8}>
                                <Widget data={{
                                    height: '447px',
                                    background: 'white',
                                    border: null,
                                    title: 'sectorEnergyConsumption',
                                    icon: 'Bolt',
                                    tooltip:
                                        <MouseoverTooltip data={{
                                            iconText: [
                                                { text: t('IPPUTooltip') },
                                                { text: t('AFOLUTooltip') },
                                            ],
                                        }} />,
                                    charts: [
                                        {
                                            chartType: 'simpleDonutChartApex',
                                            chartId: 'donutChartOne',
                                            chartQuery: '/unified_temporary/ciris/energyBySector',
                                            idQuery: 'getEnergyBySector',
                                        }
                                    ]
                                }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} energyType={energyTypeSelected} />
                            </Col>
                            <Col span={16}>
                                <Widget data={{
                                    height: '447px',
                                    background: 'white',
                                    border: null,
                                    title: 'totalEnergyConsumption',
                                    icon: 'Bolt',
                                    charts: [
                                        {
                                            chartType: 'columnsChartApex',
                                            chartQuery: '/unified_temporary/ciris/energyEvolutionBySector',
                                            idQuery: 'getEnergyEvolutionBySector',
                                            chartId: 'verticalBarChartOne'
                                        }
                                    ]
                                }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} energyType={energyTypeSelected} />
                            </Col>
                        </Row>
                    </PageSection>
                    <div className="solve-error-ciris background-color-gray" id='Emissions flowchart'></div> {/* anchor is called here just to solve the anchors overlaying the content section, needs to be researched for acessibility */}
                    <PageSection $backgroundColor='white' className='solve-error-ciris'>
                        <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginBottom='s08'>{t('flowchartEmissions')}</Text>
                        <Widget data={{
                            height: '900px',
                            border: 'neutral-3',
                            title: 'diagramSankey',
                            icon: 'Emissions',
                            charts: [
                                {
                                    chartType: 'sankeyChart',
                                    height: '824px',
                                    width: '100%',
                                    chartQuery: '/unified_temporary/ciris/getSankeyData',
                                    idQuery: 'getSankeyChart',
                                    chartId: 'sankeyChartOne'
                                }
                            ]
                        }} yearsToFetch={yearsToFetch} fetchIsLoading={fetchIsLoading} municipalitiesToFetch={entityToFetch?.value} />
                    </PageSection>
                </>
                : null}

        </PageContent>
    )
};